<template>
  <div class="col backgroundForm">
  
  <div class="input-group col-md-4 offset-md-4">
      <select class="custom-select" id="inputGroupSelect01" v-model="captain_select_p">
        <option v-for="cp in ports" :value="cp" :key="cp.id">{{cp.long_detail}} {{cp.name_port}}</option>
      </select>
      <div class="input-group-append">
          <button class="btn btn-success" @click="mGetPhotos"><font-awesome-icon icon="images" /></button>
      </div>
  </div>
  <div class="col-12" align="center">-------------</div>
  <div class="form-row" >
    <div class="col-12" align="center">
        <button class="btn btn-info" @click="mViewMap"><font-awesome-icon icon="eye" /> Ver Mapa</button>
    </div>                        
  </div>

  <CargarMapa v-if="showMap"
    :configMapa="configMapa"
    apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
  >

    <template slot-scope="{ google, map }">
      <Marcadores
        v-for="marker in cLocationCaptains"
        :key="marker.id"
        :marker=marker
        :google="google"
        :map="map"
      />
    </template>

  </CargarMapa>
  
  <ModalPhotos
      :id-modal-boat-gallery="idModalPhotos"
      :photos="bImages"
      :name-ship="nameBoat"
      :verify-ship="noShip"
  />

  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';
  import ModalPhotos from "../verify/ModalPhotosBoat";

  import CargarMapa from "./LoadMap";
  import Marcadores from "./MarksMaps";
  

  import { configMapa } from "@/constants/configMapaRead";
  import MarksMapsVue from './MarksMaps.vue';

  import capitania_menor from '@/assets/images/capitania_menor.png'
  import capitania_mayor from '@/assets/images/capitania_mayor.jpg'
  import base_naval from '@/assets/images/base_naval.jpg'
  import pma from '@/assets/images/pma.jpg'
  import oscar from '@/assets/images/oscar.png'
  

  export default {
    components: {
      CargarMapa,
      Marcadores
    },
    mounted(){
      this.callCaptains();
    },
    data() {
      return {
        showMap:false,
        send_dispatch:true,
        renderComponent:false,
        ports:[],
        captain_select_p:{id:0, name_port:null},
        idModalPhotos:'idCaptainsPhoto',
        bImages:[],
        nameBoat:null,
        noShip:false
      };
    },
    methods:{
      mViewMap(){
        this.showMap=true;
      },
      mConvertRadial(coord=-1){
                
        let coordenada_aux=coord<0 ? coord * -1: 0;

        let entero=0;
        let minuto=0;
        let minuto_aux=0;
        let segundo=0;

        let coordenada_end=null;

        entero=Math.trunc(coordenada_aux);
        minuto_aux=coordenada_aux-entero;
        minuto=Math.trunc(minuto_aux*60);

        segundo=Math.trunc((minuto-minuto_aux)*60);

        coordenada_end=`${entero}° ${minuto}' ${segundo}''`;
        return coordenada_end;

      },
      async callCaptains(){
        let cp=await axios.get(`getPortsComplete?api_token=${Vue.auth.getToken()}`);
        // console.log(cp);
        this.ports=cp.data;
        // console.log(cp.data);
        // armar los datos y enviarlo al storage
        let marksCaptain=[];

        // let img = new this.google.maps.MarkerImage(logo)
        // console.log(logo);
        // console.log(this.ports);
        cp.data.forEach((cap, index) => {
          let ic_aux;
          
          switch(cap.category_port){
            case 'CAPITANIA DE PUERTO MAYOR':
              ic_aux= capitania_mayor;
            break;
            
            case 'CAPITANIA DE PUERTO MENOR':
              ic_aux= capitania_menor;
            break;
            
            default:
              ic_aux= oscar;
              break;
          }
          

          let w_aux=cap.category_port==='CAPITANIA DE PUERTO MAYOR' ? 40:40;
          let h_aux=cap.category_port==='CAPITANIA DE PUERTO MAYOR' ? 30:40;
          
          
          
          let lat=this.mConvertRadial(cap.latitud);
          let lon=this.mConvertRadial(cap.longitud);

          let fVerfoto=function (){
            console.log('viendo la foto local');
          }

          let location={
            id:index,
            position:{lat:parseFloat(cap.latitud), lng:parseFloat(cap.longitud)},
            icon:ic_aux,
            size:{width:w_aux, height:h_aux},
            title:`${cap.category_port} ${cap.name_port}`,
            description:`<div id="content" class="card">
                          <div class="card-body">
                            <h6 class="card-title">${cap.category_port} ${cap.name_port}</h6>
                            <p class="card-text"><b>Distrito:</b> ${cap.distrito}</p>
                            <p class="card-text"><b>Departamento:</b> ${cap.departament}</p>
                            <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                          </div>
                        </div>`,
            jurisdiccion:[]
          }
          marksCaptain.push(location);
        });
        // let btn = document.getElementById('btn_photo_captain').addEventListener('click', fVerfoto, false);
        this.$store.dispatch('sGoogleMaps/addMarkersCaptains', marksCaptain); 
      },
      async mGetPhotos() {
            // obtenemos las fotografias del 
            this.nameBoat=this.captain_select_p.name_port;
            try {
                this.bImages = [];
                let ext;
                // let photo = await axios.get(
                // `getPhotos/${id}/N`
                // );

                let photo = await axios.get(`getPhotosCaptain/${this.captain_select_p.id}?api_token=${Vue.auth.getToken()}`);
                console.log(photo);
                photo.data.forEach(e => {
                    switch (e.extention) {
                        case "jpg":
                        ext = "jpeg";
                        break;

                        case "png":
                        ext = "png";
                        break;
                    }

                    let ap = {
                        id: e.id_photo,
                        path: `data:image/${ext};base64,${e.path}`,
                        title: e.title,
                        description:e.description,
                        image_principal:null
                    };
                    this.bImages.push(ap);
                    });

                    // this.bImages = this.bImages.find(e => {
                    // return e.image_principal === 1;
                    // });
                
            } catch (error) {
                console.error(error);
            }
            this.mShowModalSD(this.idModalPhotos);
        },
        mShowModalSD(idM) {
          $("#" + idM).modal("show");
        },
        mCloseModalSD(idM) {
          $("#" + idM).modal("hide");
        }
    },
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      }, 
      cDtsUser(){
        return this.$store.getters.getUserState;
      },     
      cLocationCaptains(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getMarkersCaptain'];
      },
      mapCenter() {
        // return this.markers[0].position;
        return this.cLocationCaptains[0].position;
      },
    }
  };
  
</script>


// WEBPACK FOOTER //
// src/components/maps/MapsCaptainView.vue